import { Injectable } from '@angular/core'
import { environment } from '@exchange/environment'
import { ODataConfigurationBase } from 'common-services'

@Injectable()
export class ODataConfiguration extends ODataConfigurationBase {
  constructor() {
    super()
    this.baseUrl = environment.apiroot
  }
}

@Injectable()
export class TmODataConfiguration extends ODataConfigurationBase {
  constructor() {
    super()
    this.baseUrl = `${environment.tmapiroot}/odata`
  }
}

@Injectable()
export class TmrODataConfiguration extends ODataConfigurationBase {
  constructor() {
    super()
    this.baseUrl = `${environment.rmapiroot}/odata`
  }
}

@Injectable()
export class SmODataConfiguration extends ODataConfigurationBase {
  constructor() {
    super()
    this.baseUrl = `${environment.smapiroot}/odata`
  }
}
